import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { TooltipBase, LoaderButton, IconLabel } from "ctia-ui";
import ReqLink from "components/RequestsLink";
import ActionIcons from "components/request/StaffActionIcons";
import {
  isRequesttWithdrawn,
  getRequestTypeTitle,
  needHideActions
} from "helpers/RequestHelper";
import { formatDate } from "helpers/DateHelper";
import NoTableData from "components/NoTableData";

const ListRow = ({
  tableData,
  isStaffUser,
  isVendorUser,
  isCTIAStaffUser,
  openWithdrawConfirm,
  openUnwithdrawConfirm
}) => {
  if (!tableData) return null;

  if (_.isEmpty(tableData)) {
    return <NoTableData />;
  }

  const renderWithdrawLink = row => {
    if (!isCTIAStaffUser && !isVendorUser) return null;

    const withdrawned = isRequesttWithdrawn(row.requeststatusid);
    if (withdrawned) return null;
    return (
      <LoaderButton
        bsStyle="danger"
        bsSize="xsmall"
        text={<IconLabel label="Withdraw" awesomeIcon="ban" />}
        onClick={() => openWithdrawConfirm(row)}
      />
    );
  };

  const renderWithdrawInfo = row => {
    const withdrawned = isRequesttWithdrawn(row.requeststatusid);
    if (!withdrawned) return null;

    return (
      <div>
        <div>Request Withdrawn on {formatDate(row.withdrawnat)}</div>
        <div style={{ marginTop: 5 }}>
          <TooltipBase tipText={row.withdrawreason} tipPlacement="left">
            <LoaderButton
              bsStyle="info"
              bsSize="xsmall"
              text={
                <IconLabel label="Withdrawal Reason" awesomeIcon="question" />
              }
              onClick={() => null}
              style={{ marginRight: 10 }}
            />
          </TooltipBase>
          {isCTIAStaffUser && (
            <LoaderButton
              bsStyle="success"
              bsSize="xsmall"
              text={<IconLabel label="Unwithdraw" awesomeIcon="undo" />}
              onClick={() => openUnwithdrawConfirm(row)}
            />
          )}
        </div>
      </div>
    );
  };

  return _.map(tableData, row => {
    const tn = row.formatedtransactionnumber;
    const hasPendingDocs = row.ismanualpending > 0;
    const hasPendingReports = row.nreportspending > 0;
    const hasUploadedInvoice = row.paid ? row.paid > 0 : false;
    const requestType = getRequestTypeTitle(row.requesttypeid);
    const showActions = isCTIAStaffUser && !needHideActions(tableData);
    return (
      <tr key={row.id}>
        <ActionIcons
          show={showActions}
          hasPendingDocs={hasPendingDocs}
          hasPendingReports={hasPendingReports}
          hasUploadedInvoice={hasUploadedInvoice}
        />
        <td>
          <ReqLink linkTitle={tn} requestId={row.id} />
        </td>
        {isStaffUser && <td>{row.name}</td>}
        <td>{row.modelnumber}</td>
        <td>{row.display}</td>
        <td>{requestType}</td>
        <td>
          {renderWithdrawLink(row)}
          {renderWithdrawInfo(row)}
        </td>
      </tr>
    );
  });
};

ListRow.propTypes = {
  tableData: PropTypes.array,
  isStaffUser: PropTypes.bool,
  isVendorUser: PropTypes.bool,
  isCTIAStaffUser: PropTypes.bool,
  openWithdrawConfirm: PropTypes.func,
  openUnwithdrawConfirm: PropTypes.func
};

export default ListRow;



// WEBPACK FOOTER //
// ./src/components/request/ListRow.js